import { Button, Container, Flex, InverseCorner, Text } from '@mode/components';
import React from 'react';

import { BlockWrapper, ContentContainer, GridContainer, Block } from './CoreCapabilitiesBlock.styles';
import { MobileGrid } from './MobileGrid';
import { Box, Nav, ExternalArrow } from '@mode/components';
import Image from 'gatsby-plugin-sanity-image'
import { getLinkHref } from '@lib/helpers';

const Icon = ({ src }) => (
  <Box css={{ mb: '10px', width: '24px', height: '24px', position: 'relative' }}>
    <Image {...src} alt={src.alt} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
  </Box>
)

export const CoreCapabilitiesBlock = ({
  eyebrow,
  heading,
  subheading,
  adHocTitle,
  adHocIcon,
  adHocLink,
  selfServeTitle,
  selfServeIcon,
  selfServeLink,
  dataVisualizationTitle,
  dataVisualizationIcon,
  dataVisualizationLink,
  customDataAppsTitle,
  customDataAppsIcon,
  customDataAppsLink,
  advancedAnalyticsTitle,
  advancedAnalyticsIcon,
  advancedAnalyticsLink,
  link,
  paddingTop,
  paddingBottom,
  buttons
}) => {
  return (
    <BlockWrapper
      css={{
        paddingTop: paddingTop ?? "$sm",
        paddingBottom: paddingBottom ?? "$sm",
        "@md": {
          paddingTop: paddingTop ?? "$md",
          paddingBottom: paddingBottom ?? "$md",
        },
      }}>
      <Container>
        <Box css={{ background: '$g4', borderRadius: '$16' }}>
          <Flex justify="space-between" wrap="wrap">
            <ContentContainer>
              <Box>
                <Text textStyle="eyebrow" color="$g2">{eyebrow}</Text>
                <Text textStyle="h2" as="h2" color="$g1" css={{ py: '$xs' }}>{heading}</Text>
                <Text textStyle="p1" color="$g1" css={{ pb: '$xs', '@md': { pb: '$sm' } }}>{subheading}</Text>
                {link.length > 0 &&
                <Nav.Link
                  to={getLinkHref(link[0])}
                  css={{ color: '$g1', display: 'flex', alignItems: 'center', cursor: 'pointer', 'svg': { width: '12px', height: '14px', transition: 'transform 350ms cubic-bezier(1, 0.1, 0.1, 1)' }, 'svg path': { stroke: '$g1', transition: 'stroke 150ms ease-in-out' }, '&:hover': { color: '$g2', 'svg': { transform: 'translateY(10px)', transition: 'transform 350ms cubic-bezier(1, 0.1, 0.1, 1)' }, 'svg path': { stroke: '$g2', transition: 'stroke 150ms ease-in-out' } } }}>
                  <Box as="span" css={{ pr: '$xxxxs' }}>
                    {link[0].label}
                  </Box>
                  <ExternalArrow />
                </Nav.Link>
                }
                {buttons && buttons.map((button, index) => {
                  return (
                    <Button
                      as={button.calendly ? "button" : "link"}
                      key={button._key}
                      variant={button.type}
                      to={button.url}
                      calendly={button.calendly}
                      calendlyUrl={button.calendlyUrl}
                      css={{ ml: index === 0 ? 0 : '$xxxs' }}
                      dark
                    >
                      {button.label}
                    </Button>
                  )
                })}
              </Box>
            </ContentContainer>
            <MobileGrid
              eyebrow={eyebrow}
              heading={heading}
              subheading={subheading}
              adHocTitle={adHocTitle}
              adHocIcon={adHocIcon}
              selfServeTitle={selfServeTitle}
              selfServeIcon={selfServeIcon}
              dataVisualizationTitle={dataVisualizationTitle}
              dataVisualizationIcon={dataVisualizationIcon}
              customDataAppsTitle={customDataAppsTitle}
              customDataAppsIcon={customDataAppsIcon}
              advancedAnalyticsTitle={advancedAnalyticsTitle}
              advancedAnalyticsIcon={advancedAnalyticsIcon}
              adHocLink={adHocLink}
              selfServeLink={selfServeLink}
              dataVisualizationLink={dataVisualizationLink}
              customDataAppsLink={customDataAppsLink}
              advancedAnalyticsLink={advancedAnalyticsLink}
              link={link}
            />
            <GridContainer css={{ display: 'none', '@md': { display: 'grid' } }}>
              <Block
                as="a"
                href={`/${adHocLink?.slug.current}`}
                css={{
                  background: '$g2',
                  height: '180px',
                  borderRadius: '$16',
                }}
              >
                <Box>
                  <Icon src={adHocIcon} />
                  {adHocTitle}
                </Box>
              </Block>
              <Block
                as="a"
                href={`/${dataVisualizationLink?.slug.current}`}
                css={{ background: '$g2', height: '150px', borderRadius: '$16', position: 'relative', gridColumn: '2 / span 2', borderBottomLeftRadius: 0 }}>
                <Block css={{
                  position: 'absolute',
                  width: '54%',
                  height: '130%',
                  left: 0,
                  top: '100%',
                  borderBottomLeftRadius: '$16',
                  borderBottomRightRadius: '$16',
                  zIndex: 1,
                }}>
                  <InverseCorner position="topRight" fg="$g4" />
                  <Box>
                    <Icon src={dataVisualizationIcon} />
                    {dataVisualizationTitle}
                  </Box>
                </Block>
              </Block>
              <Block
                as="a"
                href={`/${selfServeLink?.slug.current}`}
                css={{ background: '$g2', borderRadius: '$16', gridRow: '2 / span 2', position: 'relative', borderBottomRightRadius: 0 }}>
                <Box css={{ position: 'absolute' }}>
                  <Box>
                    <Icon src={selfServeIcon} />
                    {selfServeTitle}
                  </Box>
                </Box>
                <Box
                  css={{
                    position: 'absolute',
                    width: '34%',
                    height: '47%',
                    background: '$g2',
                    bottom: 0,
                    right: '-34%',
                    borderTopRightRadius: '$16',
                    borderBottomRightRadius: '$16'
                  }}
                >
                  <InverseCorner position="topLeft" bg='$g2' fg="$g4" css={{ transform: 'rotate(180deg) translate(0%, 100%)', zIndex: '0' }} />
                </Box>
              </Block>
              <Block
                as="a"
                href={`/${customDataAppsLink?.slug.current}`}
                css={{ background: '$g2', borderRadius: '$16', width: '72%', position: 'relative', left: '25%', gridRow: '3 / span 1' }}>
                <Box>
                  <Icon src={customDataAppsIcon} />
                  {customDataAppsTitle}
                </Box>
              </Block>
              <Block
                as="a"
                href={`/${advancedAnalyticsLink?.slug.current}`}
                css={{ background: '$g2', borderRadius: '$16', gridColumn: '3 / span 1', gridRow: '2 / span 2', height: '108%', top: '-8%', right: '3%', position: 'relative', width: '103%' }}>
                <Box>
                  <Icon src={advancedAnalyticsIcon} />

                  {advancedAnalyticsTitle}
                </Box>
              </Block>
            </GridContainer>
          </Flex>
        </Box>
      </Container>
    </BlockWrapper>
  )
}